import { Routes } from '@angular/router';
import { MainLayoutComponent } from './shared/components/layout/main-layout/main-layout';
import { BotMeetingLinksLayout } from './shared/components/layout/bot-meeting-links-layout/bot-meeting-links-layout';
import { AuthGuard } from './core/guards/auth-guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./modules/auth/auth-layout.routes').then((m) => m.authLayoutRoutes),
  },

  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'meeting',
        pathMatch: 'full', 
      },
      {
        path: '',
        loadChildren: () => import('./modules/meetings/meetings.routes').then((m) => m.meetingsRoutes),
      },
      {
        path:'',
        loadChildren: () => import('./modules/users/users.routes').then((m) => m.usersRoutes),
      },
      {
        path: 'bot-setup',
        loadChildren: () => import('./modules/bot-meeting-links/bot-meeting-links.routes').then((m) => m.botMeetingLinksRoutes),
      },
      {
        path: 'bot/:id',
        loadComponent: () => import('./modules/bot-meeting-links/bot/bot').then(m => m.Bot),
        data: { title: 'Bot Details' }
      },
      {
        path: 'history',
        loadComponent: () => import('./modules/bot-meeting-links/history/history').then(m => m.History),
        data: { title: 'Bot History' }
      },
    ]
  }
];
